import React, {Component} from 'react';
import ListingsHeaderV2 from '../../MainListing/ListingsHeaderV2';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  FlatList,
  TextInput,
  Dimensions,
  Alert,
  Platform,
  Image,
  SafeAreaView,
} from 'react-native';
import edit_Icon from '../../assets/editIcon.png';
import deleteIcon from '../../assets/delete_icon.png';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import colors from '../../HelperClasses/AppColor';
import networkService from '../../Network/NetworkManager';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import PropTypes from 'prop-types';
import AddAttribute from './AddAttributeValues';
import EmptyListUI from '../../Component/AppEmptyList';
import addIcon from '../../assets/add_icon.png';
import dropIcon from '../../assets/dropIcon.png';
import addIconGry from '../../assets/addIconGray.png';
import disableIcon from '../../assets/disableIcon.png';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import {
  checkUserRoleModule,
  attributeType,
} from '../../HelperClasses/SingletonClass';
import {MODULEKEYS} from '../../Models/Enum';
import AppConstants from '../../Constants/AppConstants';
import {AppToast} from '../../HelperClasses/AppToast';
import {
  addMixpanelEvent,
  MixpanelEvent,
  MixPannelEnum,
} from '../../Models/MixPannelEnum';
import CommonStyleSheet from '../../StyleSheets/CommonStyleSheet';
import {getThumbnailImage} from '../../HelperClasses/SingletonClass';
import SaveButton from '../../Component/SaveButton';
import SecondryButton from '../../Component/SecondryButton';
import AddAttributes from './AddAttributes';
import {ToastContainer} from 'react-toastify';
import EditBulkScreen from './EditBulk';
import {TranslateEnum} from '../../Models/TranslateEnum';
import Translations from './Translation';
import {RestrictedFeatureEnum} from '../../Models/RestrictedFeatureEnum';
import SubscribePlan from '../../Component/SubscribePlan';
import placeholder from '../../assets/pPlaceholder.png';
import {TypeEnum} from '../../Models/CommonEnum';
import {withRouter} from '../../wrappers/withRouter';
import {createSearchParams, useNavigate} from 'react-router-dom';
import Modal from '../../Component/UI/modals/Modal';
import {loadAttributesGroup} from '../Attributes/actions/attributeGroupActions';
import GenerateText from '../../utils/AI/GenerateText';
import {instructions} from '../../Constants/Instructions';
import {replacePlaceholders} from '../../utils/replacePlaceholders';
import HelperLinkView from '../../Component/HelperLinkView';
import CartSetting from '../GlobalSettings/CartSetting';
import OrderNotification from '../Notifications/OrderNotification';
import OrdersSettings from '../GlobalSettings/OrdersSettings';
import SidePanView from '../../Component/SidePanView';
import settingIcon from '../../assets/settingIcon.png';
import BackBtnView from '../../Component/BackBtnView';
import {ThemeContext} from '../../HelperClasses/ThemeContext';
import {getFeatureLimit, hasReachedFeatureLimit} from '../../utils/featureEntitlements';
import {withLocale} from '../../Localization/LocaleContext';
const APPURL = require('./../../Constants/URLConstants');

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

let fixedWidth = AppConstants.mobileMaxWidth;
let itsMobileView = windowWidth < fixedWidth ? true : false;

class AttributesList extends Component {
  static contextType = ThemeContext;
  translate = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
  constructor(props) {
    super(props);
    this.state = {
      attributeArray: [],
      dataLoad: false,
      updateUI: false,
      attributeData: [],
      isEdit: false,
      selectedAttributeID: 0,
      addAttributeBool: false,
      selectedAttributeName: '',
      haveData: false,
      readP: AppConstants.defaultWrite,
      writeP: AppConstants.defaultWrite,
      deleteP: AppConstants.defaultDelete,
      addAttributeValuesBool: false,
      editBulkBool: false,
      translationBool: false,
      showCartSettings: false,
      selectedData: '',
      showUpgrade: false,
      savingSettings: false,
      currentType: '',
      attrGroups: null,
    };
    this.handleRLDDChange = this.handleRLDDChange.bind(this);
  }
  static propTypes = {
    editBtn: PropTypes.func,
    type: PropTypes.string,
    addAttibuteValues: PropTypes.func,
  };
  componentDidMount() {
    this.loadAttributeApi();
    this.checkModule();
    addMixpanelEvent(`${this.props.type} ${MixpanelEvent.viewAttribute}`, {
      type: MixPannelEnum.listView,
    });
  }
  componentDidUpdate() {
    if (this.state.currentType.length != 0) {
      if (this.state.currentType != this.props.type) {
        this.setState({
          showUpgrade: false,
          editBulkBool: false,
          dateLoad: false,
          translationBool: false,
          addAttributeValuesBool: false,
          addAttributeBool: false,
        });
        this.loadAttributeApi();
      }
    }
  }
  checkModule = () => {
    let moduleKey =
      this.props.type == TypeEnum.listings
        ? MODULEKEYS.LISTIINGSATTRIBUTE
        : MODULEKEYS.ACCOUNTSATTRIBUTE;
    if (this.props.type == TypeEnum.users) {
      moduleKey = MODULEKEYS.USERSATTRIBUTE;
    }
    checkUserRoleModule(moduleKey, res => {
      this.setState({readP: res[0], writeP: res[1], deleteP: res[2]});
    });
  };
  //MARK:-  APIS Method 
  loadAttributeApi = async () => {
    this.setState({dataLoad: false});
    let path = attributeType(this.props.type);
    this.state.currentType = this.props.type;
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.attributes + `?type=${path}`,
      'get',
    );
    this.setState({attributeArray: []});
    if (responseJson['status'] == true) {
      var attriD = responseJson['data']['attributes'];
      for (let i = 0; i < attriD.length; i++) {
        this.state.attributeArray.push(attriD[i]);
      }
      this.state.haveData =
        this.state.attributeArray.length == 0 ? true : false;
    } else {
      this.alertView(responseJson);
    }
    this.setState({dataLoad: true});
  };

  deleteAtrrApi = async id => {
    this.setState({dataLoad: false});
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.attributes + '/' + id,
      'delete',
      '',
      '',
    );
    this.setState({dataLoad: true});
    if (responseJson['status'] == true) {
      this.mixpanelInfo(true);
      this.loadAttributeApi();
      this.alertView('delete');
    } else {
      this.mixpanelInfo(false);
    }
  };
  mixpanelInfo(resp) {
    let properties = {success: resp};
    addMixpanelEvent(
      `${this.props.type} ${MixpanelEvent.deleteAttribute}`,
      properties,
    );
  }
  bulkAttributeAPI = async data => {
    var dict = [];
    var i = 1;
    for (let objc of data) {
      var doc = {
        order_by: i,
        id: objc['id'],
      };
      dict.push(doc);
      i++;
    }
    var path = APPURL.URLPaths.attributes + APPURL.URLPaths.bulk;
    const responseJson = await networkService.networkCall(
      path,
      'PATCH',
      JSON.stringify({attributes: dict}),
    );
    if (responseJson['status'] == true) {
    } else {
    }
  };
  alertView(title) {
    if (Platform.OS === 'web') {
      // alert(title);
      AppToast(title);
    } else {
      Alert.alert(title);
    }
  }

  editButtonAction = index => {
    let id_Index = this.state.attributeArray.findIndex(x => x.id === index);
    this.props.navigate({
      pathname: `/edit-attribute/${this.state.attributeArray[id_Index].id}`,
      search: createSearchParams({
        type: this.props.type,
      }).toString(),
    });
  };

  addAttributeBtnAction() {
    if (this.hasReachedAttributeLimit()) {
      this.setState({showUpgrade: true});
      return;
    }
    this.props.navigate({
      pathname: '/add-attribute',
      search: createSearchParams({
        type: this.props.type,
      }).toString(),
    });
  }
  addAttributeValueBtnAction = index => {
    let id_Index = this.state.attributeArray.findIndex(x => x.id === index);

    this.setState({
      selectedAttributeName: this.state.attributeArray[id_Index]['name'],
      selectedAttributeID: this.state.attributeArray[id_Index]['id'],
      addAttributeValuesBool: !this.state.addAttributeValuesBool,
    });
  };
  // addAttributeValueBtnAction = index => {
  //   let id_Index = this.state.attributeArray.findIndex(x => x.id === index);
  //   // console.log('selectedAttributeName', id_Index);
  //   this.setState({
  //     selectedAttributeName: this.state.attributeArray[id_Index]['name'],
  //     selectedAttributeID: this.state.attributeArray[id_Index]['id'],
  //     addAttributeBool: !this.state.addAttributeBool,
  //   });
  // }
  deleteAttributeAction = index => {
    let msg = this.translate('attributes.confirm_delete', 'Do you want to delete this attribute?');
    if (Platform.OS === 'web') {
      const r = window.confirm(msg);
      if (r == true) {
        this.deleteAtrrApi(index);
      }
    }
  };
  backBtnAction() {
    this.loadAttributeApi();
    this.setState({
      editBulkBool: false,
      addAttributeBool: false,
      addAttributeValuesBool: false,
      translationBool: false,
    });
  }
  handleRLDDChange(reorderedItems) {
    this.state.attributeArray = reorderedItems;
    this.setState({updateUI: !this.state.updateUI});
    this.bulkAttributeAPI(reorderedItems);
  }
  /*  UI   */
  tableViewHeader = props => {
    return (
      <FlatList
        data={tableHeaderString}
        horizontal={true}
        renderItem={this.tableHeaderCell}
        extraData={this.state}
        showsVerticalScrollIndicator={false}
        scrollEnabled={false}
      />
    );
  };
  tableHeaderCell = ({item, index}) => {
    const themeColors = this.context?.colors ?? colors;
    return (
      <View
        style={
          index == 0
            ? styles.firstCellTableViewTitleViewStyle
            : styles.tableViewTitleViewStyle
        }>
        <Text
          className="listing-attributes-table-header-text"
          style={[tableStyle.tableViewTitleStyle, {color: themeColors.primaryText}]}>
          {this.translate(`attributes.header_${String(item).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '')}`, item)}
        </Text>
      </View>
    );
  };
  columnDataView = props => {
    const themeColors = this.context?.colors ?? colors;
    if (this.state.attributeArray.length == 0) {
      if (this.state.haveData) {
        return (
          <View style={{height: windowHeight / 2}}>
            <EmptyListUI showImage={true} />
          </View>
        );
      } else {
        return <View />;
      }
    } else {
      var views = [];
      for (let i = 0; i < this.state.attributeArray.length; i++) {
        let categories = this.state.attributeArray[i]['categories'];
        let catAry = [];
        for (let obj of categories) {
          catAry.push(obj['name']);
        }
        let fldType = this.state.attributeArray[i]['field_type'];
        let val = typesArray[fldType - 1];
        views.push(
          <FlatList
            data={[
              this.state.attributeArray[i]['name'],
              this.state.attributeArray[i]['id'],
              this.state.attributeArray[i]['id'],
              val,
              this.state.attributeArray[i]['optional'],
              this.state.attributeArray[i]['icon_path'] ?? '',
              catAry.toString(),
              !this.state.attributeArray[i]['visible'],
              this.state.attributeArray[i]['id'],
              this.state.attributeArray[i]['active'],
            ]}
            style={{backgroundColor: themeColors.cardBackground}}
            horizontal={true}
            renderItem={this.columnCell}
            extraData={this.state}
            showsVerticalScrollIndicator={false}
            scrollEnabled={true}
          />,
        );
      }
      return (
        <View style={{flexDirection: 'row', flex: 1}}>
          <View style={{display: this.state.writeP ? 'flex' : 'none'}}>
            <RLDD
              items={this.state.attributeArray}
              itemRenderer={this.renderDragDropView}
              onChange={this.handleRLDDChange}
            />
          </View>
          <View
            style={{display: !this.state.writeP ? 'flex' : 'none', width: 22}}
          />
          <View style={{flexDirection: 'column'}}>{views}</View>
        </View>
      );
    }
  };
  renderDragDropView = (item, index) => {
    const themeColors = this.context?.colors ?? colors;
    let categories = item['categories'];
    let catAry = [];
    for (let obj of categories) {
      catAry.push(obj['name']);
    }
    return (
      <View>
        <FlatList
          data={[catAry.toString()]}
          style={{backgroundColor: themeColors.cardBackground}}
          horizontal={true}
          renderItem={this.renderDropdownCell}
          extraData={this.state}
          showsVerticalScrollIndicator={false}
          scrollEnabled={false}
        />
      </View>
    );
  };
  renderDropdownCell = ({item}) => {
    return (
      <View style={tableStyle.dragdropViewStyle}>
        <Image
          style={tableStyle.dragIconStyle}
          resizeMode="center"
          source={dropIcon}
        />
      </View>
    );
  };
  columnCell = ({item, index}) => {
    const themeColors = this.context?.colors ?? colors;
    if (index == 4 || index == 9 || index == 7) {
      var val =
        index == 5
          ? item == false
            ? 'Yes'
            : 'No'
          : item == true
          ? 'Yes'
          : 'No';
      let check = index == 5 ? (item == false ? true : false) : item;
      if (index == 9) {
        val = item ? this.translate('accounts.active', 'Active') : this.translate('accounts.inactive', 'Inactive');
      } else {
        val = item === true ? this.translate('common.yes', 'Yes') : item === false ? this.translate('common.no', 'No') : val;
      }
      return (
        <View
          style={[
            styles.columnTitleViewStyle,
            {
              backgroundColor: themeColors.cardBackground,
              borderBottomColor: themeColors.borderColor,
            },
          ]}>
          <Text
            style={[
              check == true
                ? tableStyle.columnActiveBtnStyle
                : tableStyle.columnDeActiveBtnStyle,
              {
                // The shared table style uses the light palette at module
                // load time. Reapply the semantic colors here so status pills
                // remain readable when the dark theme is active.
                color: check ? themeColors.AppNewGreen : themeColors.AppRed,
                backgroundColor: check
                  ? themeColors.UltraLightGreen
                  : themeColors.UltraLightRed,
                borderColor: check
                  ? themeColors.Appgreen
                  : themeColors.AppButtonRed,
              },
            ]}>
          {typeof val === 'object' ? this.translate(`attributes.type_${String(val?.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '')}`, val?.name) : val}
          </Text>
        </View>
      );
    } else if (index == 1) {
      return (
        <View
          style={[
            styles.columnTitleViewStyle,
            {
              backgroundColor: themeColors.cardBackground,
              borderBottomColor: themeColors.borderColor,
            },
          ]}>
          <View style={{flexDirection: 'row'}}>
            {this.renderEditBtn(item)}
            <View style={{width: 10}} />
            {this.renderDeleteBtn(item)}
          </View>
        </View>
      );
    } else if (index == 5) {
      let fileUrl = getThumbnailImage(item);
      return (
        <View
          style={[
            styles.columnTitleViewStyle,
            {
              backgroundColor: themeColors.cardBackground,
              borderBottomColor: themeColors.borderColor,
            },
          ]}>
          <View style={{marginLeft: 0}}>
            <Image
              style={tableStyle.itemImageViewStyle}
              source={item.length == 0 ? placeholder : fileUrl}
            />
          </View>
        </View>
      );
    } else if (index == 8) {
      let id_Index = this.state.attributeArray.findIndex(x => x.id === item);
      let fldType = this.state.attributeArray[id_Index]['field_type'];
      if (fldType == 1 || fldType == 2) {
        let values = this.state.attributeArray[id_Index]['values'];
        return (
          <View
            style={[
              styles.columnTitleViewStyle,
              {
                backgroundColor: themeColors.cardBackground,
                borderBottomColor: themeColors.borderColor,
              },
            ]}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
              <Text style={[CommonStyleSheet.plainTextStyle, {color: themeColors.primaryText}]}>
                {values.length}
              </Text>
            </View>
          </View>
        );
      } else {
        return (
          <View
            style={[
              styles.columnTitleViewStyle,
              {
                backgroundColor: themeColors.cardBackground,
                borderBottomColor: themeColors.borderColor,
              },
            ]}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
              <Text style={[CommonStyleSheet.plainTextStyle, {color: themeColors.primaryText}]}>0</Text>
            </View>
          </View>
        );
      }
    } else if (index == 2) {
      let id_Index = this.state.attributeArray.findIndex(x => x.id === item);
      let fldType = this.state.attributeArray[id_Index]['field_type'];
      if (fldType == 1 || fldType == 2) {
        return (
          <View
            style={[
              styles.columnTitleViewStyle,
              {
                backgroundColor: themeColors.cardBackground,
                borderBottomColor: themeColors.borderColor,
              },
            ]}>
            <TouchableOpacity
              disabled={!this.state.writeP}
              onPress={() => this.addAttributeValueBtnAction(item)}>
              <Image
                style={tableStyle.iconStyle}
                resizeMode="center"
                source={this.state.writeP ? addIcon : disableIcon}
              />
            </TouchableOpacity>
          </View>
        );
      } else {
        return (
          <View
            style={[
              styles.columnTitleViewStyle,
              {
                backgroundColor: themeColors.cardBackground,
                borderBottomColor: themeColors.borderColor,
              },
            ]}>
            <View>
              <Image
                style={tableStyle.iconStyle}
                resizeMode="center"
                source={this.state.writeP ? addIconGry : disableIcon}
              />
            </View>
          </View>
        );
      }
    } else if (index == 0) {
      return (
        <View
          style={[
            styles.firstCellViewStyle,
            {
              backgroundColor: themeColors.cardBackground,
              borderBottomColor: themeColors.borderColor,
            },
          ]}>
          <View
            style={{flexDirection: 'row', justifyContent: 'center', flex: 1}}>
            {/* <Image style={styles.iconStyle} resizeMode="center" source={dropIcon} /> */}
            <Text style={[tableStyle.columnViewTitleStyle, {color: themeColors.primaryText}]} numberOfLines={2}>
              {item}
            </Text>
          </View>
        </View>
      );
    } else {
      return (
        <View
          style={[
            styles.columnTitleViewStyle,
            {
              backgroundColor: themeColors.cardBackground,
              borderBottomColor: themeColors.borderColor,
            },
          ]}>
          <Text style={[tableStyle.columnViewTitleStyle, {color: themeColors.primaryText}]} numberOfLines={3}>
            {item}
          </Text>
        </View>
      );
    }
  };
  renderEditBtn = item => {
    return (
      <TouchableOpacity
        disabled={!this.state.writeP}
        onPress={() => this.editButtonAction(item)}>
        <Image
          style={tableStyle.iconStyle}
          resizeMode="center"
          source={this.state.writeP ? edit_Icon : disableIcon}
        />
      </TouchableOpacity>
    );
  };
  renderDeleteBtn = item => {
    return (
      <TouchableOpacity
        disabled={!this.state.deleteP}
        onPress={() => this.deleteAttributeAction(item)}>
        <Image
          style={tableStyle.iconStyle}
          resizeMode="center"
          source={this.state.deleteP ? deleteIcon : disableIcon}
        />
      </TouchableOpacity>
    );
  };
  checkRestriction() {
    let check = AppConstants.restrictedFeatureArray.includes(
      RestrictedFeatureEnum.attributes,
    );
    return check;
  }
  getAttributeLimit = () => getFeatureLimit(RestrictedFeatureEnum.attributes);
  hasReachedAttributeLimit = () =>
    hasReachedFeatureLimit(
      RestrictedFeatureEnum.attributes,
      this.state.attributeArray.length,
    );
  renderSecondryBtnView = ({id}) => {
    return (
      <View>
        <SecondryButton
          btnDeActive={this.checkRestriction() || !this.state.writeP}
          showBtn={true}
          btnTitle={id == 2 ? this.translate('attributes.edit_bulk', 'Edit Bulk') : this.translate('category.translate', 'Translate')}
          deActiveBtnAction={() =>
            this.state.writeP && this.setState({showUpgrade: true})
          }
          btnAction={() =>
            id == 2
              ? this.setState({editBulkBool: true})
              : this.setState({translationBool: true})
          }
        />
      </View>
    );
  };
  renderCartSettingsView = () => {
    if (this.props.type !== 'cart_attributes' || !this.state.showCartSettings) {
      return null;
    }
    return (
      <SidePanView
        customWidth={true}
        fullHeight={true}
        showSidepanView={this.state.showCartSettings}
        dissmissView={() => this.setState({showCartSettings: false})}
        title={this.translate('attributes.cart_settings', 'Cart settings')}
        customView={
          <ScrollView style={styles.settingsPaneContent}>
            <View style={styles.settingsSection}>
              <CartSetting
              compact={true}
              ref={child => {
                this.cartSettingsChild = child;
              }}
              />
            </View>
            <View style={styles.settingsSection}>
              <OrdersSettings
                compact={true}
                ref={child => {
                  this.ordersSettingsChild = child;
                }}
              />
            </View>
            <View style={styles.settingsSection}>
              <Text style={styles.settingsSectionTitle}>
                {this.translate('attributes.order_status_notifications', 'Order status notifications')}
              </Text>
            <OrderNotification
              compact={true}
              ref={child => {
                this.orderNotificationChild = child;
              }}
            />
            </View>
            <SaveButton
              saveBtn={() => this.saveCartAndOrderSettings()}
              saveBtnTitle={this.translate('common.save', 'Save')}
              showSaveBtn={true}
            />
            <Appload enable={!this.state.savingSettings} />
          </ScrollView>
        }
      />
    );
  };
  saveCartAndOrderSettings = async () => {
    this.setState({savingSettings: true});
    try {
      if (this.cartSettingsChild) {
        await this.cartSettingsChild.saveBtnAction();
      }
      if (this.ordersSettingsChild) {
        await this.ordersSettingsChild.saveBtnAction();
      }
      if (this.orderNotificationChild) {
        await this.orderNotificationChild.saveButtonAction();
      }
    } finally {
      this.setState({savingSettings: false});
    }
  };
  renderHeaderView = () => {
    const themeColors = this.context?.colors ?? colors;
    var bView = [];
    if (this.props.type != TypeEnum.users) {
      bView.push(
        <View>
          <this.renderSecondryBtnView id={2} />
        </View>,
      );
    }
    const ins =
      this.props.type == 'Listings'
        ? instructions.listing_attribute
        : instructions.account_attribute;

    return (
      <ListingsHeaderV2
        simple={true}
        titleArea={
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
          {(this.props.type === 'cart_attributes' ||
            this.props.type === 'Users') && (
            <TouchableOpacity
              style={tableStyle.backBtnBackViewStyle}
              onPress={() =>
                this.props.navigate(
                  this.props.type === 'Users' ? '/users' : '/settings',
                )
              }>
              <BackBtnView />
            </TouchableOpacity>
          )}
          <Text style={[tableStyle.titleTextStyle, {margin: 0, marginLeft: 16, color: themeColors.primaryText}]}>{/* title */}
            {this.props.type === 'cart_attributes'
              ? this.translate('attributes.cart_checkout', 'Cart & Checkout')
              : this.translate('attributes.title', 'Attributes')}{' '}
          </Text>
          {(this.props.type === 'Listings' ||
            this.props.type === 'Accounts') && (
            <GenerateText
              user_id={AppConstants.userId}
              system_instruction={ins.system}
              user_message={replacePlaceholders({
                template: ins.user,
                data: {
                  expectations:
                    AppConstants?.tenant_metadata?.expectations ?? 'c2c',
                },
              })}
            />
          )}
          </View>
        }
        actionControl={
          <View style={{flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
          {this.props.type === 'cart_attributes' && (
            <TouchableOpacity
              accessibilityLabel={this.translate('attributes.cart_settings', 'Cart settings')}
              onPress={() => this.setState({showCartSettings: true})}
              style={styles.settingsButton}>
              <Image
                source={settingIcon}
                resizeMode="contain"
                style={styles.settingsIcon}
              />
            </TouchableOpacity>
          )}
          {bView}
          <SecondryButton
            btnDeActive={this.checkRestriction() || !this.state.writeP}
            showBtn={true}
            btnTitle={this.translate('attributes.groups', 'Attribute Groups')}
            btnAction={() => {
              this.state.writeP &&
                this.props.navigate(
                  '/attribute-groups?' +
                    `type=${attributeType(this.props.type)}`,
                );
            }}
          />
          <this.renderSecondryBtnView id={1} />
          <SaveButton
            btnDeActive={
              this.checkRestriction() ||
              this.hasReachedAttributeLimit() ||
              !this.state.writeP
            }
            deActiveBtnAction={() =>
              this.state.writeP &&
              (this.checkRestriction() || this.hasReachedAttributeLimit()) &&
              this.setState({showUpgrade: true})
            }
            saveBtn={() => this.addAttributeBtnAction()}
            saveBtnTitle={this.translate('attributes.add_attribute', 'Add Attribute')}
            showLock={true}
          />
          </View>
        }
      />
    );
  };
  renderUpgradePlanView = () => {
    if (!this.state.showUpgrade) return null;
    return <SubscribePlan upgrade featureKey={RestrictedFeatureEnum.attributes} contextLabel="Custom attributes" onClose={() => this.setState({showUpgrade: false})} />;
  };
  render() {
    if (this.state.addAttributeValuesBool) {
      return (
        <ScrollView style={{flexDirection: 'column'}}>
          <AddAttribute
            type={this.props.type}
            isEdit={this.state.isEdit}
            attributeName={this.state.selectedAttributeName}
            attributeID={this.state.selectedAttributeID}
            backBtnAction={() => this.backBtnAction()}
          />
        </ScrollView>
      );
    } else if (this.state.addAttributeBool) {
      return (
        <View style={{flexDirection: 'column'}}>
          <ToastContainer />
          <AddAttributes
            type={this.props.type}
            isEdit={this.state.isEdit}
            attributeData={this.state.selectedData}
            closeBtnAction={() => this.setState({addAttributeBool: false})}
            backBtnAction={() => this.backBtnAction()}
          />
        </View>
      );
    } else if (this.state.editBulkBool) {
      return (
        <View style={{flexDirection: 'column'}}>
          <ToastContainer />
          <EditBulkScreen
            titleString={this.props.type}
            bulkTitle={this.translate('attributes.editor_attributes', 'Attributes')}
            bulkRef={TranslateEnum.attribute}
            backBtnAction={() => this.backBtnAction()}
          />
        </View>
      );
    } else if (this.state.translationBool) {
      return (
        <View style={{flexDirection: 'column'}}>
          <ToastContainer />
          <Translations
            titleString={this.props.type}
            translationTitle={this.translate('attributes.editor_attributes', 'Attributes')}
            translationRef={TranslateEnum.attribute}
            backBtnAction={() => this.setState({translationBool: false})}
          />
        </View>
      );
    } else {
      const themeColors = this.context?.colors ?? colors;
      return (
        <SafeAreaView
          style={[
            styles.Container,
            {
              backgroundColor:
                this.context?.colors?.screenBackground ?? colors.AppLightGreen,
            },
          ]}
          className="listing-attributes-page">
          <ToastContainer />
          <View style={{zIndex: 9999}}>{this.renderCartSettingsView()}</View>
          <View style={{zIndex: 101}}>
            <this.renderUpgradePlanView />
          </View>
          <View style={{zIndex: 1}}>
            <this.renderHeaderView />
            <View
              style={[
                tableStyle.containerMainView,
                {
                  backgroundColor: themeColors.cardBackground,
                  borderColor: themeColors.borderColor,
                },
              ]}>
              <ScrollView
                style={[
                  tableStyle.mainScrollViewStyle,
                  {backgroundColor: themeColors.cardBackground},
                ]}
                horizontal={true}>
                {this.state.readP && (
                  <View>
                    <View
                      style={{
                        height: 45,
                        backgroundColor: themeColors.tableHeaderBackground,
                        borderTopStartRadius: 5,
                        borderTopEndRadius: 5,
                      }}>
                      <this.tableViewHeader />
                    </View>
                    <ScrollView
                      style={[
                        styles.tableViewHeaderStyle,
                        {backgroundColor: themeColors.cardBackground},
                      ]}>
                      <this.columnDataView />
                    </ScrollView>
                  </View>
                )}
              </ScrollView>
            </View>
            {attributeType(this.props.type) === TypeEnum.cart_attributes && (
              <HelperLinkView title={this.translate('attributes.editor_cart_attributes', 'Cart Attributes')} />
            )}
            <Appload enable={this.state.dataLoad} />
          </View>
        </SafeAreaView>
      );
      //}
    }
  }
}

export default withRouter(withLocale(AttributesList));
const divideWidth = 9.8;
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: colors.AppLightGreen,
  },
  settingsButton: {
    width: 40,
    height: 40,
    marginRight: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  settingsIcon: {
    width: 24,
    height: 24,
  },
  settingsPaneContent: {
    height: windowHeight - 150,
    paddingBottom: 20,
  },
  settingsSection: {
    paddingBottom: 0,
    marginBottom: 0,
  },
  settingsSectionTitle: {
    color: colors.AppNewGreen,
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 4,
  },
  tableViewTitleViewStyle: {
    padding: 0,
    width: windowWidth < fixedWidth ? 130 : windowWidth / divideWidth,
    paddingLeft: 35,
  },
  firstCellTableViewTitleViewStyle: {
    padding: 0,
    width: 150,
    paddingLeft: 35,
  },
  columnTitleViewStyle: {
    width: windowWidth < fixedWidth ? 130 : windowWidth / divideWidth,
    borderBottomWidth: 1,
    borderBottomColor: colors.SimonGray,
    padding: 20,
    paddingLeft: 10,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    height: 70,
  },
  firstCellViewStyle: {
    width: 150,
    paddingLeft: 10,
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: 'white',
    justifyContent: 'flex-start',
    borderBottomWidth: 1,
    borderBottomColor: colors.SimonGray,
    // padding: 20,
    height: 70,
  },
  tableViewHeaderStyle: {
    backgroundColor: 'white',
    borderRadius: 5,
    zIndex: 1,
    width: '100%',
    padding: 0,
  },
});

const tableHeaderString = [
  'Attribute Name',
  'Action',
  'Manage Attribute Values',
  'Type',
  'Optional',
  'Icon',
  'Categories',
  'Hidden Field',
  'Values',
  'Status',
];

let typesArray = [
  'Single Select',
  'Multi Select',
  'Open (Single Value)',
  'Open (Multiple Value)',
  'Attachment',
  'Text Area',
  'Date Time',
  'Number',
  'Boolean',
  'Color',
  'Json',
  'Location',
  'Audio',
  'Video',
];
